// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Scoped under .ns-daterange — safe to use in any module */
.ns-daterange {
  position: relative;
  width: 100%;
  min-width: 0;
}

.ns-daterange__label {
  font-size: 12px;
  font-weight: 500;
  color: #6b7785;
  margin: 0 0 4px;
  display: block;
}

.ns-daterange__trigger {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-height: 38px;
  height: 38px;
  padding: 0 12px 0 14px;
  text-align: left;
  cursor: pointer;
  background: #fff;
  overflow: hidden;
  line-height: 1.25;
}

.ns-daterange__trigger-wrap {
  position: relative;
  width: 100%;
}

.ns-daterange__trigger-wrap .ns-daterange__trigger {
  padding-right: 36px;
}

.ns-daterange__clear {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 22px;
  height: 22px;
  border: none;
  border-radius: 50%;
  background: #eef1f5;
  color: #6b7785;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  z-index: 1;
}

.ns-daterange__clear:hover {
  background: #e2e7ee;
  color: #1a2332;
}

.ns-daterange__trigger:focus {
  outline: none;
  border-color: #4c5fd5;
  box-shadow: 0 0 0 2px rgba(76, 95, 213, 0.2);
}

.ns-daterange__icon {
  flex-shrink: 0;
  color: #6b7785;
  font-size: 16px;
  margin-right: 2px;
}

.ns-daterange__trigger-value {
  flex: 1 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: 500;
  color: #1a2332;
}

.ns-daterange__popover {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  z-index: 1060;
  background: #fff;
  border: 1px solid #e8ecf1;
  border-radius: 10px;
  box-shadow: 0 12px 32px rgba(5, 27, 44, 0.16);
  overflow: hidden;
  min-width: 280px;
  max-width: 320px;
}

/* Portaled to body — avoids overflow:hidden clipping in filter cards */
.ns-daterange__popover--portal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2000;
}

.ns-daterange__popover--with-calendar {
  min-width: min(calc(100vw - 24px), 640px);
  max-width: min(calc(100vw - 24px), 640px);
}

.ns-daterange__body {
  display: flex;
  align-items: stretch;
}

.ns-daterange__sidebar {
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
  border-right: 1px solid #eef1f5;
}

.ns-daterange__popover--with-calendar .ns-daterange__sidebar {
  flex: 0 0 200px;
  min-width: 200px;
  width: auto;
}

.ns-daterange__popover:not(.ns-daterange__popover--with-calendar) .ns-daterange__sidebar {
  border-right: none;
}

.ns-daterange__preset-list {
  list-style: none;
  margin: 0;
  padding: 6px 0;
  max-height: 320px;
  overflow-y: auto;
}

.ns-daterange__preset-list li {
  margin: 0;
}

.ns-daterange__preset-item {
  display: block;
  width: 100%;
  border: none;
  background: transparent;
  text-align: left;
  padding: 10px 16px;
  font-size: 14px;
  color: #1a2332;
  cursor: pointer;
  line-height: 1.3;
}

.ns-daterange__preset-item:hover {
  background: #f4f7fc;
}

.ns-daterange__preset-item--active {
  background: #4c5fd5;
  color: #fff;
  font-weight: 600;
}

.ns-daterange__preset-item--active:hover {
  background: #3d4ec4;
}

.ns-daterange__calendar-pane {
  flex: 1 1 auto;
  min-width: 0;
  overflow: auto;
}

.ns-daterange__picker-wrap .rdrDateRangePickerWrapper {
  display: block;
}

.ns-daterange__picker-wrap .rdrDefinedRangesWrapper {
  display: none !important;
  width: 0 !important;
  min-width: 0 !important;
  border: none !important;
}

.ns-daterange__picker-wrap .rdrCalendarWrapper {
  font-size: 13px;
  width: 100%;
}

.ns-daterange__picker-wrap .rdrMonths {
  justify-content: center;
}

.ns-daterange__picker-wrap .rdrDayToday .rdrDayNumber span:after {
  background: #4c5fd5;
}

.ns-daterange__picker-wrap .rdrStartEdge,
.ns-daterange__picker-wrap .rdrEndEdge {
  color: #4c5fd5 !important;
}

.ns-daterange__picker-wrap .rdrInRange {
  color: #dce3ff !important;
}

.ns-daterange__footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 14px;
  border-top: 1px solid #eef1f5;
  background: #fff;
}

.ns-daterange__footer-range {
  font-size: 12px;
  color: #6b7785;
  flex: 1 1 auto;
  min-width: 0;
  display: block;
}

.ns-daterange__footer-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-left: auto;
}

.ns-daterange__footer .btn_theme_primary,
.ns-daterange__footer .btn_theme_secondary {
  min-width: 72px;
  font-size: 13px;
  padding: 7px 12px;
  margin: 0;
  flex: 0 0 auto;
}

/* Compact preset-only panel: keep all actions visible */
.ns-daterange__popover:not(.ns-daterange__popover--with-calendar) .ns-daterange__footer {
  flex-direction: column;
  align-items: stretch;
}

.ns-daterange__popover:not(.ns-daterange__popover--with-calendar) .ns-daterange__footer-range {
  flex: 1 1 100%;
}

.ns-daterange__popover:not(.ns-daterange__popover--with-calendar) .ns-daterange__footer-actions {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  width: 100%;
  margin-left: 0;
  justify-content: stretch;
}

.ns-daterange__popover:not(.ns-daterange__popover--with-calendar) .ns-daterange__footer-actions .btn_theme_primary,
.ns-daterange__popover:not(.ns-daterange__popover--with-calendar) .ns-daterange__footer-actions .btn_theme_secondary {
  flex: 1 1;
  width: auto;
  min-width: 0;
}

@media (max-width: 700px) {
  .ns-daterange__popover {
    left: auto;
    right: 0;
  }

  .ns-daterange__popover--with-calendar {
    min-width: min(calc(100vw - 24px), 340px);
    max-width: min(calc(100vw - 24px), 340px);
  }

  .ns-daterange__body {
    flex-direction: column;
  }

  .ns-daterange__sidebar {
    flex: none;
    min-width: 0;
    border-right: none;
    border-bottom: 1px solid #eef1f5;
  }

  .ns-daterange__picker-wrap .rdrMonths {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/DateRangePicker/DateRangePicker.css"],"names":[],"mappings":"AAAA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,uEAAuE;AACvE;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;AACf;;AAEA;EACE,yCAAyC;EACzC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,cAAc;AAChB;;AAEA,wDAAwD;AACxD;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,QAAQ;EACR,WAAW;EACX,cAAc;EACd,wBAAwB;AAC1B;;AAEA;;EAEE,SAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,UAAU;IACV,QAAQ;EACV;;EAEA;IACE,yCAAyC;IACzC,yCAAyC;EAC3C;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":["/* Scoped under .ns-daterange — safe to use in any module */\n.ns-daterange {\n  position: relative;\n  width: 100%;\n  min-width: 0;\n}\n\n.ns-daterange__label {\n  font-size: 12px;\n  font-weight: 500;\n  color: #6b7785;\n  margin: 0 0 4px;\n  display: block;\n}\n\n.ns-daterange__trigger {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  min-height: 38px;\n  height: 38px;\n  padding: 0 12px 0 14px;\n  text-align: left;\n  cursor: pointer;\n  background: #fff;\n  overflow: hidden;\n  line-height: 1.25;\n}\n\n.ns-daterange__trigger-wrap {\n  position: relative;\n  width: 100%;\n}\n\n.ns-daterange__trigger-wrap .ns-daterange__trigger {\n  padding-right: 36px;\n}\n\n.ns-daterange__clear {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 22px;\n  height: 22px;\n  border: none;\n  border-radius: 50%;\n  background: #eef1f5;\n  color: #6b7785;\n  font-size: 16px;\n  line-height: 1;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  z-index: 1;\n}\n\n.ns-daterange__clear:hover {\n  background: #e2e7ee;\n  color: #1a2332;\n}\n\n.ns-daterange__trigger:focus {\n  outline: none;\n  border-color: #4c5fd5;\n  box-shadow: 0 0 0 2px rgba(76, 95, 213, 0.2);\n}\n\n.ns-daterange__icon {\n  flex-shrink: 0;\n  color: #6b7785;\n  font-size: 16px;\n  margin-right: 2px;\n}\n\n.ns-daterange__trigger-value {\n  flex: 1;\n  min-width: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: 14px;\n  font-weight: 500;\n  color: #1a2332;\n}\n\n.ns-daterange__popover {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  z-index: 1060;\n  background: #fff;\n  border: 1px solid #e8ecf1;\n  border-radius: 10px;\n  box-shadow: 0 12px 32px rgba(5, 27, 44, 0.16);\n  overflow: hidden;\n  min-width: 280px;\n  max-width: 320px;\n}\n\n/* Portaled to body — avoids overflow:hidden clipping in filter cards */\n.ns-daterange__popover--portal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 2000;\n}\n\n.ns-daterange__popover--with-calendar {\n  min-width: min(calc(100vw - 24px), 640px);\n  max-width: min(calc(100vw - 24px), 640px);\n}\n\n.ns-daterange__body {\n  display: flex;\n  align-items: stretch;\n}\n\n.ns-daterange__sidebar {\n  flex: 1 1 auto;\n  min-width: 0;\n  width: 100%;\n  border-right: 1px solid #eef1f5;\n}\n\n.ns-daterange__popover--with-calendar .ns-daterange__sidebar {\n  flex: 0 0 200px;\n  min-width: 200px;\n  width: auto;\n}\n\n.ns-daterange__popover:not(.ns-daterange__popover--with-calendar) .ns-daterange__sidebar {\n  border-right: none;\n}\n\n.ns-daterange__preset-list {\n  list-style: none;\n  margin: 0;\n  padding: 6px 0;\n  max-height: 320px;\n  overflow-y: auto;\n}\n\n.ns-daterange__preset-list li {\n  margin: 0;\n}\n\n.ns-daterange__preset-item {\n  display: block;\n  width: 100%;\n  border: none;\n  background: transparent;\n  text-align: left;\n  padding: 10px 16px;\n  font-size: 14px;\n  color: #1a2332;\n  cursor: pointer;\n  line-height: 1.3;\n}\n\n.ns-daterange__preset-item:hover {\n  background: #f4f7fc;\n}\n\n.ns-daterange__preset-item--active {\n  background: #4c5fd5;\n  color: #fff;\n  font-weight: 600;\n}\n\n.ns-daterange__preset-item--active:hover {\n  background: #3d4ec4;\n}\n\n.ns-daterange__calendar-pane {\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow: auto;\n}\n\n.ns-daterange__picker-wrap .rdrDateRangePickerWrapper {\n  display: block;\n}\n\n.ns-daterange__picker-wrap .rdrDefinedRangesWrapper {\n  display: none !important;\n  width: 0 !important;\n  min-width: 0 !important;\n  border: none !important;\n}\n\n.ns-daterange__picker-wrap .rdrCalendarWrapper {\n  font-size: 13px;\n  width: 100%;\n}\n\n.ns-daterange__picker-wrap .rdrMonths {\n  justify-content: center;\n}\n\n.ns-daterange__picker-wrap .rdrDayToday .rdrDayNumber span:after {\n  background: #4c5fd5;\n}\n\n.ns-daterange__picker-wrap .rdrStartEdge,\n.ns-daterange__picker-wrap .rdrEndEdge {\n  color: #4c5fd5 !important;\n}\n\n.ns-daterange__picker-wrap .rdrInRange {\n  color: #dce3ff !important;\n}\n\n.ns-daterange__footer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 10px 14px;\n  border-top: 1px solid #eef1f5;\n  background: #fff;\n}\n\n.ns-daterange__footer-range {\n  font-size: 12px;\n  color: #6b7785;\n  flex: 1 1 auto;\n  min-width: 0;\n  display: block;\n}\n\n.ns-daterange__footer-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-left: auto;\n}\n\n.ns-daterange__footer .btn_theme_primary,\n.ns-daterange__footer .btn_theme_secondary {\n  min-width: 72px;\n  font-size: 13px;\n  padding: 7px 12px;\n  margin: 0;\n  flex: 0 0 auto;\n}\n\n/* Compact preset-only panel: keep all actions visible */\n.ns-daterange__popover:not(.ns-daterange__popover--with-calendar) .ns-daterange__footer {\n  flex-direction: column;\n  align-items: stretch;\n}\n\n.ns-daterange__popover:not(.ns-daterange__popover--with-calendar) .ns-daterange__footer-range {\n  flex: 1 1 100%;\n}\n\n.ns-daterange__popover:not(.ns-daterange__popover--with-calendar) .ns-daterange__footer-actions {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 8px;\n  width: 100%;\n  margin-left: 0;\n  justify-content: stretch;\n}\n\n.ns-daterange__popover:not(.ns-daterange__popover--with-calendar) .ns-daterange__footer-actions .btn_theme_primary,\n.ns-daterange__popover:not(.ns-daterange__popover--with-calendar) .ns-daterange__footer-actions .btn_theme_secondary {\n  flex: 1 1 0;\n  width: auto;\n  min-width: 0;\n}\n\n@media (max-width: 700px) {\n  .ns-daterange__popover {\n    left: auto;\n    right: 0;\n  }\n\n  .ns-daterange__popover--with-calendar {\n    min-width: min(calc(100vw - 24px), 340px);\n    max-width: min(calc(100vw - 24px), 340px);\n  }\n\n  .ns-daterange__body {\n    flex-direction: column;\n  }\n\n  .ns-daterange__sidebar {\n    flex: none;\n    min-width: 0;\n    border-right: none;\n    border-bottom: 1px solid #eef1f5;\n  }\n\n  .ns-daterange__picker-wrap .rdrMonths {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
